import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  Avatar,
  Divider,
  IconButton,
  useMediaQuery
} from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import axios from "axios";
import { is } from "date-fns/locale";

const CategoryPage = ({ onCategorySelect }) => {
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");

  const scrollRef = useRef(null);
  const isMobile = useMediaQuery("(max-width:600px)");

  // Fetch categories
  useEffect(() => {
    axios
      .get("https://reviewhub-lc.onrender.com/api/categories")
      .then((res) => setCategories(res.data))
      .catch((err) => console.error("Error fetching categories:", err));
  }, []);

  // Fetch subcategories
  useEffect(() => {
    axios
      .get("https://reviewhub-lc.onrender.com/api/subcategories")
      .then((res) => setSubcategories(res.data))
      .catch((err) => console.error("Error fetching subcategories:", err));
  }, []);

  // Group subcategories based on selection
  const groupedSubcategories = subcategories
    .filter(
      (item) =>
        !selectedCategory || item.categoryId?.categoryName === selectedCategory
    )
    .reduce((acc, item) => {
      const group = item.gender || "Others";
      if (!acc[group]) acc[group] = [];
      acc[group].push(item);
      return acc;
    }, {});

  // Scroll category bar (desktop only)
  const scrollCategories = (direction) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === "left" ? -200 : 200,
        behavior: "smooth"
      });
    }
  };
  const formatNameWithLineBreak = (name) => {
  const words = name.trim().split(" ");
  if (words.length === 2) {
    return (
      <>
        {words[0]}
        <br />
        {words[1]}
      </>
    );
  }
  return name;
};


  return (
    <Box sx={{ p: 0 ,mx:isMobile ? 0 : 5, }}>
      {isMobile ? (
        // 📱 MOBILE VIEW
        <Grid container spacing={2}>
          {/* Categories Left */}
          <Grid
            item
            xs={4}
            sx={{
              maxHeight: "80vh",
              overflowY: "auto",
              borderRight: "1px solid #ddd"
            }}
          >
            {categories.map((cat) => (
             <Paper
  key={cat._id}
  elevation={1}
  onClick={() =>
    setSelectedCategory(
      selectedCategory === cat.categoryName ? "" : cat.categoryName
    )
  }
  sx={{
    mb: 1,
    p: 1,
    marginRight: 1,
    textAlign: "center",
    cursor: "pointer",
    backgroundColor: "#f0f0f0",
    width: 52, // smaller width
    height: 70, // smaller height
    border:
      selectedCategory === cat.categoryName
        ? "2px solid blue"
        : "1px solid #ccc",
  }}
>
  <Avatar
    src={`https://reviewhub-lc.onrender.com/uploads/${cat.image}`}
    alt={cat.categoryName}
    variant="rounded"
    sx={{ width: 36, height: 36, mx: "auto", mb: 0.3 }}
  />
<Typography variant="caption" sx={{ fontSize: "0.6rem", lineHeight: 1.1, whiteSpace: "normal" }}>
  {formatNameWithLineBreak(cat.categoryName)}
</Typography>

</Paper>

            ))}
          </Grid>

          {/* Subcategories Right (Show all or filtered) */}
     <Grid item xs={8} sx={{ overflowY: "auto", maxHeight: "80vh", maxWidth:240 }} >
  {Object.entries(groupedSubcategories).map(([group, items]) => (
    <Box key={group} sx={{ mb: 2, width: "100%" }}>
      <Typography
        variant="subtitle2"
        sx={{ fontWeight: "bold", mb: 1 }}
      >
        {group}
      </Typography>
      <Grid container spacing={1} wrap="wrap" sx={{ minWidth: 50 }}>
        {items.map((item) => (
          <Grid
            item
            xs={6}
            sm={4}
            sx={{ minWidth: 50 }}
            key={item._id}
          >
         <Paper
  elevation={1}
  onClick={() =>
    onCategorySelect(
      item.categoryId?.categoryName,
      item.subCategoryName
    )
  }
  sx={{
    p: 0.5,
    textAlign: "center",
    cursor: "pointer",
    transition: "transform 0.2s",
    "&:hover": { transform: "scale(1.03)" },
    width: 60, // reduce width
    height: 75, // reduce height
  }}
>
  <Avatar
    src={
      item.image
        ? `https://reviewhub-lc.onrender.com/uploads/subcategories/${item.image}`
        : ""
    }
    alt={item.subCategoryName}
    variant="rounded"
    sx={{ width: 36, height: 36, mx: "auto", mb: 0.3 }}
  />
<Typography variant="caption" sx={{ fontSize: "0.6rem", lineHeight: 1.1, whiteSpace: "normal" }}>
  {formatNameWithLineBreak(item.subCategoryName)}
</Typography>

</Paper>

          </Grid>
        ))}
      </Grid>
    </Box>
  ))}
</Grid>

        </Grid>
      ) : (
        // 🖥 DESKTOP VIEW
        <>
          <Typography variant="h5" gutterBottom>
            Categories
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              position: "relative",
              mb: 3
            }}
          >
            <IconButton
              onClick={() => scrollCategories("left")}
              sx={{
                position: "absolute",
                left: -20,
                zIndex: 2,
                bgcolor: "white"
              }}
            >
              <ArrowBackIos />
            </IconButton>

            <Box
              ref={scrollRef}
      sx={{
  display: "flex",
  gap: 2,
  overflowX: "hidden", // ✅ disables manual scrolling
  scrollBehavior: "smooth",
  px: 5
}}

            >
              {categories.map((cat) => (
                <Paper
                  key={cat._id}
                  elevation={3}
                  onClick={() =>
                    setSelectedCategory(
                      selectedCategory === cat.categoryName
                        ? ""
                        : cat.categoryName
                    )
                  }
                  sx={{
                    minWidth: 120,
                    height: 110,
                    backgroundColor: "#ddd7d7ff",
                    p: 2,
                    textAlign: "center",
                    cursor: "pointer",
                    border:
                     
                      selectedCategory === cat.categoryName
                        ? "2px solid blue"
                        : "none"
                  }}
                >
                  <Avatar
                    src={`https://reviewhub-lc.onrender.com/uploads/${cat.image}`}
                    alt={cat.categoryName}
                    variant="rounded"
                    sx={{ width: 90, height: 90, mb: 1, mx: "auto" }}
                  />
                  <Typography variant="body2">{cat.categoryName}</Typography>
                </Paper>
              ))}
            </Box>

            <IconButton
              onClick={() => scrollCategories("right")}
              sx={{
                position: "absolute",
                right: -20,
                zIndex: 2,
                bgcolor: "white"
              }}
            >
              <ArrowForwardIos />
            </IconButton>
          </Box>

          <Divider sx={{ mb: 3 }} />

          {/* Grouped Subcategories */}
          {Object.entries(groupedSubcategories).map(([group, items]) => (
            <Box key={group} sx={{ mb: 4 }}>
              <Typography
                variant="h6"
                gutterBottom
                sx={{ fontWeight: "bold", color: "#333" }}
              >
                {group}
              </Typography>
              <Grid container spacing={3}>
                {items.map((item) => (
           <Grid item xs={4} sm={3} md={2} sx={{ minWidth: 72 }} key={item._id}>

                    <Paper
                      elevation={3}
                      onClick={() =>
                        onCategorySelect(
                          item.categoryId?.categoryName,
                          item.subCategoryName
                        )
                      }
                      sx={{
                        width: 160,
                        height: 180,
                        p: 2,
                        textAlign: "center",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        transition: "transform 0.2s",
                        "&:hover": { transform: "scale(1.05)" }
                      }}
                    >
                      <Avatar
                        src={
                          item.image
                            ? `https://reviewhub-lc.onrender.com/uploads/subcategories/${item.image}`
                            : ""
                        }
                        alt={item.subCategoryName}
                        variant="rounded"
                        sx={{ width: 120, height: 120, mb: 1 }}
                      />
                      <Typography variant="body1" sx={{ mt: 1 }}>
                        {item.subCategoryName}
                      </Typography>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Box>
          ))}
        </>
      )}
    </Box>
  );
};

export default CategoryPage;
